module.exports = __webpack_public_path__ + "img/upperBody.d914391b.svg";